<section class="container">
  <div class="api-docs-tabs">
    <div class="tab" [class.active]="currentTab === 'getting-started'" (click)="setTab('getting-started')">
      Getting Started
    </div>
    <div class="tab" [class.active]="currentTab === 'authentication'" (click)="setTab('authentication')">
      Authentication
    </div>
    <div class="tab" [class.active]="currentTab === 'reference'" (click)="setTab('reference')">
      Endpoints
    </div>
    <div class="tab" [class.active]="currentTab === 'test-scenarios'" (click)="setTab('test-scenarios')">
      Test scenarios
    </div>
  </div>

  <div class="tab-content" *ngIf="currentTab === 'getting-started'">
    <ifbp-getting-started (navigate)="setTab($event)"></ifbp-getting-started>
  </div>
  <div class="tab-content" *ngIf="currentTab === 'authentication'">
    <ifbp-authentication (navigate)="setTab($event)"></ifbp-authentication>
  </div>
  <div class="tab-content" *ngIf="currentTab === 'reference'">
    <div class="api-info-banner">
      <a href="assets/api-docs/postman-collection/BrokerAPI.postman_collection.json" download class="postman-link">
        Download Postman Collection
      </a>
    </div>

    <elements-api id="partner-api-endpoints"
                  [apiDescriptionDocument]="apiDocsJson"
                  basePath="/admin/api-docs"
                  layout="stacked"
                  hideSchemas="true"
                  hideTryIt="true"
                  hideExport ="true">
    </elements-api>
  </div>

  <div class="tab-content" *ngIf="currentTab === 'test-scenarios'">
    <ifbp-test-scenarios (navigate)="setTab($event)"></ifbp-test-scenarios>
  </div>

  <ifbp-advisor-widget-button [data]="advisorWidgetData"></ifbp-advisor-widget-button>
</section>
